import { renderBlocks } from '@/components/blocks';
import { ProgrammeDetails } from '@/components/blocks/ProgrammeDetails';
import { Layout } from '@/components/layout/Layout';
import { useDynamicYield } from '@/lib/useDynamicYield';

const SharedProgrammeLayout = ({
  programme,
  siteSettings,
  locale,
  draftMode,
  navigation,
}) => {
  const { recommendationContext } = useDynamicYield(locale, 'PRODUCT', [
    programme.title,
  ]);

  return (
    <Layout
      SEO={programme?.SEO}
      siteSettings={siteSettings}
      preview={draftMode}
      navigation={navigation}
      recommendationContext={recommendationContext}
    >
      <ProgrammeDetails programme={programme} locale={locale} />
      {renderBlocks(programme?.blocks)}
    </Layout>
  );
};

export { SharedProgrammeLayout };
